<div class="hint-container">
  <img src="../../../images/Sparkles.svg" alt="" />
  <div class="content">
    <span>Hint:</span>
    <ng-content></ng-content>
  </div>
</div>
